import { selectLastConsultation } from '@app/store/consultation/consultation.selectors';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AllowanceState } from '../allowance.state';
import { StateNamesEnum } from '@app/shared/utils/enums/state-names.enum';

export const selectAllowance = createFeatureSelector<AllowanceState>(StateNamesEnum.ALLOWANCE);

/**
 * Select previous visit full recommendation
 */
const selectPreviousRecommendation = createSelector(
  selectLastConsultation,
  (previousConsultation) => previousConsultation?.visit?.recommendation,
);
/**
 * Select current visit nutrition recommendation
 */
export const selectCurrentRecommendation = createSelector(selectAllowance, (state) => state?.nutritionRecommendation);
/**
 * Select default visit nutrition recommendation (calculated when arriving on the DAC page when nothing is set manually)
 */
const selectDefaultRecommendation = createSelector(selectAllowance, (state) => state?.defaultNutritionRecommendation);
/**
 * Select current visit gestation nutrition recommendation
 */
export const selectGestationRecommendation = createSelector(selectAllowance, (state) => state?.gestationNutritionRecommendation);

/**
 * Select current recommendation kcal value
 */
export const selectCurrentRecommendationKcalAllocation = createSelector(
  selectCurrentRecommendation,
  (recommendation) => recommendation?.diagnostic.kCalAllocation,
);
/**
 * Select recommendation kcal value for default recommendation (without manual ration or allocation)
 */
export const selectDefaultRecommendationKcalAllocation = createSelector(
  selectDefaultRecommendation,
  (recommendation) => recommendation?.diagnostic.kCalAllocation,
);
/**
 * Select last recommendation kcal value
 */
export const selectPreviousRecommendationKcalAllocation = createSelector(
  selectPreviousRecommendation,
  (recommendation) => recommendation?.diagnostic.kCalAllocation,
);
/**
 * Select loading recommendation;
 * To know if we're waiting for a new recommendation or an update
 */
export const selectLoadingRecommendation = createSelector(selectAllowance, (state) => state?.loadingRecommendation);

export const selectBlockCurrentlyEditing = createSelector(selectAllowance, (state) => state?.blockCurrentlyEditing);

export const selectAllowanceStep = createSelector(selectAllowance, (state) => state?.step);

export const selectWetQuantityPerDay = createSelector(selectAllowance, (state) => state?.allWetQuantityPerDay);

export const selectTreatsQuantityPerDay = createSelector(selectAllowance, (state) => state?.allTreatsQuantityPerDay);
